import Swiper from "swiper";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export default function swiperListingCards() {
    const swiperElement = document.querySelector(".listing-cards-swiper");
    if (!swiperElement) return;

    const init = () => {
        // Only init if visible (or just always init since it's hidden by CSS on desktop)
        // We check width just to be safe and consistent with CSS breakpoint (1500px for xxl)
        if (window.innerWidth < 1500) {
            new Swiper(swiperElement, {
                modules: [Pagination],
                slidesPerView: 1.2,
                spaceBetween: 20,
                centeredSlides: true,
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                        centeredSlides: false,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    }
                }
            });
        }
    };

    init();
    // We don't strictly need resize listener if we rely on CSS hiding, 
    // but if we want to init on resize from desktop to mobile:
    window.addEventListener("resize", () => {
        if (!swiperElement.swiper && window.innerWidth < 1500) {
            init();
        }
    });
}
